<template>
    <v-card>

        <v-card-title v-text="`${$props.pingTarget.ping_id ? 'Edit' : 'New'} Ping Target`"></v-card-title>

        <v-divider />

        <v-card-text>
            <v-form ref="pingTargetForm" :lazy-validation="true" v-model="formValid">
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="$props.pingTarget.ping_name" color="#c42111" label="Target Name" :rules="[$store.state.validationFuncs.required($props.pingTarget.ping_name, 'Target Name')]" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="$props.pingTarget.ping_addr" color="#c42111" label="IP Address" :rules="[$store.state.validationFuncs.required($props.pingTarget.ping_addr, 'IP Address'), $store.state.validationFuncs.noDuplicatesCaseInsensitive($props.pingTarget.ping_addr, pingAddrList)]" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="$props.pingTarget.ping_location" color="#c42111" label="Location" />
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn @click="$emit('cancel')" text>Cancel</v-btn>
            <v-btn @click="savePingTarget" text>Save</v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
export default {
    name: 'PingTargetsEdit',
    props: ['pingTarget', 'pingTargetsList'],
    components: {

    },
    data: () => ({
        formValid: true,
    }),

    computed: {
        pingAddrList() {
            let pingTargetsList = this.$props.pingTargetsList;
            if(this.$props.pingTarget.ping_id) {
                // They're editing an existing Ping Target so remove its ping_addr from the list.
                pingTargetsList = pingTargetsList.filter(x => x.ping_id != this.$props.pingTarget.ping_id);
            }
            return pingTargetsList.map(x => x.ping_addr);
        }

    },

    methods: {
        savePingTarget: function() {
            if(this.$refs.pingTargetForm.validate()) {
                this.$emit('save');
            }
        }

    },

    created() {
    }

  
};
</script>
